<template>
    <card-container>
        <transition @leave="leave" @enter="enter">
            <component
                class="x-class"
                :is="state"
                @transition-front="transitionEnterPin"
                @balance-fetched="displayBalance"
                :amount="balance.amount"
                :currency="balance.currency"
                @transition-enter-pin="transitionEnterPin"
                @reset-check-balance="resetCard"
                @goto-combine="loadCombine"
                :disable-combine="disableCombineLink"
            ></component>
        </transition>
    </card-container>
</template>

<script>
import cardContainer from '@/components/card/index';
import cardBack from '@/components/card/state/back';
import enterPin from '@/components/card/state/enter-pin';
import cardBalance from '@/components/card/state/balance';

export default {
    name: 'check-balance',
    components: { cardContainer, cardBack, enterPin, cardBalance },
    data() {
        return {
            state: 'card-back',
            balance: {
                amount: undefined,
                currency: undefined,
            },
            pin: undefined,
            initialized: false,
        };
    },
    computed: {
        disableCombineLink() {
            return this.balance.amount <= 0;
        },
    },
    mounted() {
        window.setTimeout(() => {
            this.transitionEnterPin();
        }, 1000);
    },
    methods: {
        resetCard() {
            this.state = 'enter-pin';
        },
        transitionEnterPin() {
            this.state = 'enter-pin';
        },
        displayBalance({ amount, currency, pin }) {
            this.pin = pin;
            this.balance.amount = amount;
            this.balance.currency = currency;
            this.state = 'card-balance';
        },
        loadCombine() {
            this.$router.push({
                name: 'card-combine',
                params: {
                    initCard: {
                        pin: this.pin,
                        amount: this.balance.amount,
                        currency: this.balance.currency,
                    },
                },
            });
        },
        leave(el, done) {
            if (this.initialized) {
                window.Velocity(
                    el,
                    { opacity: 0 },
                    {
                        duration: 500,
                        complete: done,
                    }
                );
            } else {
                window.Velocity(
                    el,
                    { rotateY: '90deg' },
                    { duration: 500, complete: done }
                );
            }
        },
        enter(el, done) {
            if (this.initialized) {
                window.Velocity(
                    el,
                    { opacity: 0 },
                    {
                        duration: 0,
                        complete: done,
                    }
                );
                window.Velocity(
                    el,
                    { opacity: 1 },
                    {
                        delay: 500,
                        duration: 500,
                        complete: done,
                    }
                );
            } else {
                window.Velocity(
                    el,
                    { rotateY: '-90deg' },
                    { duration: 0, complete: done }
                );
                window.Velocity(
                    el,
                    { rotateY: '0deg' },
                    { delay: 500, duration: 500, complete: done }
                );
                this.initialized = true;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.x-class {
    overflow: hidden;
    border-radius: 9px;
    @include break('md') {
        border-radius: 16px;
    }
    box-shadow: 30px 30px 30px rgba(0, 0, 0, 0.4);
}
</style>
